module.exports = __webpack_public_path__ + "static/img/bg-neirongtuijian.2bbbb77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cha/bg-neirongtuijian.png
// module id = 1563
// module chunks = 0